export default __webpack_public_path__ + "static/media/toyota-buckle-up-desktop.f20d8447.svg";